<p-card header="Catalogs" styleClass="mb-2">
    <div class="flex">
        <p-card *ngFor="let category of categories$ | async" styleClass="h-full" class="m-1 col-3">
            <span class="font-bold text-lg">{{category.name}}</span><br>
            {{category.description}}
        </p-card>
    </div>
</p-card>